import React from 'react';
import ReactDom from 'react-dom';
import { CSSTransition } from 'react-transition-group';
import PropTypes from "prop-types";

import Backdrop from './Backdrop';

import './Modal.scss';

const ModalOverlay = props => {
    const content = (
        <div className={`mastermodal ${props.className}`} style={props.style}>
            <header className={`modal-hf modal__header ${props.headerClass} `}>
                <span>{props.header}</span>
            </header>
            <form onSubmit={props.onSubmit ? props.onSubmit : event => event.preventDefault()}>
                <div className={`modal__content ${props.contentClass} `}>
                    {props.children} </div>
                <footer className={`modal-hf modal__footer ${props.footerClass} `}>
                    {props.footer}
                </footer>
            </form>
        </div>
    );
    return ReactDom.createPortal(content, document.getElementById('modal-hook'))
};


const Modal = props => { 
    return (
    <React.Fragment>
        {props.show && <Backdrop onClick={props.onCancel} />}
        <CSSTransition in={props.show} mountOnEnter unmountOnExit timeout={1700} classNames="mastermodal">
            <ModalOverlay {...props}></ModalOverlay>
        </CSSTransition>
    </React.Fragment>
    );
};

export default Modal;